module.exports = __webpack_public_path__ + "static/media/orange-pin.9e405634.png";